import globals from "../globals";

const getHeaders = (isMultipart = false, skipBusinessId = false) => {
    const headers = {}
    if (!isMultipart) headers['Content-Type'] = 'application/json';

    const token = localStorage.getItem('authToken');
    const businessId = localStorage.getItem('business_id');
    const userType = localStorage.getItem('user_type');
    if (token) headers['Authorization'] = `Bearer ${token}`;
    // if (businessId) headers['Business-Id'] = businessId;
    // if (businessId) headers['BusinessId'] = businessId;
    if (businessId && (userType !== 'owner' || !skipBusinessId)) {
        headers['Business-Id'] = businessId;
        headers['BusinessId'] = businessId;
    }


    return headers;
}


async function handleResponse(res) {

    const data = await res.json().catch(() => null);

    if (res.ok) return data;

    const isUnauthorized = res.status === 401 || data?.error === "unauthenticated";

    if (isUnauthorized) {
        localStorage.clear();

        // Optional: show toast (if you use a global toaster)
        if (window?.showToast) {
            window.showToast("Session expired. Please login again.", "error", "Auth");
        }

        // Redirect to login
        window.location.href = "/signin";
        return;
    }

    // Fallback error object
    return Promise.reject({
        status: res.status,
        message: data?.message || "Something went wrong!",
        error: data?.error || null,
        data,
    });
}





export const apiClient = {
    get: async (url) => {
        const res = await fetch(globals.baseUrl + url, {
            method: 'GET',
            headers: getHeaders(),
        });
        return handleResponse(res);
    },

    post: async (url, body = {}, isMultipart = false, skipBusinessId = false) => {
        const res = await fetch(globals.baseUrl + url, {
            method: 'POST',
            headers: getHeaders(isMultipart, skipBusinessId),
            body: isMultipart ? body : JSON.stringify(body),
        });
        return handleResponse(res);
    },

    put: async (url, body = {}) => {
        const res = await fetch(globals.baseUrl + url, {
            method: 'PUT',
            headers: getHeaders(),
            body: JSON.stringify(body),
        });
        return handleResponse(res);
    },

    delete: async (url, body = {}) => {
        const res = await fetch(globals.baseUrl + url, {
            method: 'DELETE',
            headers: getHeaders(),
            body: JSON.stringify(body),
        });

        return handleResponse(res);
    },



};